/* eslint-disable @typescript-eslint/no-explicit-any */

export namespace NClientServices {
  export type ServiceType = 'individual' | 'group' | null;

  export type Category = {
    Id: number;
    Name: string | null;
    Description: string | null;
    IsDeleted: boolean;
    BranchId?: number | null;
  };

  export type ModelClientServiceCategory = {
    Id: number;
    Name: string | null;
    Description: string | null;
    BranchId: number;
    IsDeleted: boolean;
    MigrateId: number | null;
  };

  export type Service = {
    Id: number;
    Name: string | null;
    PriceS: number;
    PriceE: number | null;
    Duration: number;
    ServiceType: ServiceType;
    CategoryId: number | null;
    Category: string | null;
    BranchId: number;
    IsDeleted: boolean;
    ClientServiceAdditions: ClientServiceAddition[] | null;
    Count?: number | null;
    UserId?: number | null;
    CountEmployees: number;
    Description?: string | null;
  };

  export type ClientServiceAddition = {
    Id: number;
    ServiceId: number;
    AdditionServiceId: number;
    Name: string | null;
  };

  export interface ModelBranchClientService
    extends Pick<
      NClientServices.Service,
      'Id' | 'Name' | 'PriceS' | 'PriceE' | 'Duration' | 'CountEmployees'
    > {
    CategoryId: NClientServices.Category['Id'];
    CategoryName: NClientServices.Category['Name'];
    CategoryDescription: NClientServices.Category['Description'];
    OrderIndex: number;
    IsCategoryDeleted: boolean;
    IsDeleted: boolean;
  }

  export type ModelClientServiceOrder = {
    ClientServiceId: number;
    ServiceCategoryId: number;
    OrderIndex: number;
  };

  export type ModelClientServiceFilter = {
    SearchTerm: string | null;
    CategoryIds: number[] | null;
  };

  export type ModelClientServiceDiscount = {
    Discount: number;
    Type: string | null;
  };

  export type ModelClientServiceLite = {
    Id: number;
    Name: string | null;
    CategoryId: number;
    Category: string | null;
    PriceS: number;
    PriceE: number | null;
    Duration: number;
    Count: number;
    UserId: number | null;
    Discount: number;
    Paid: number;
    IsDeleted: boolean;
    Discounts: ModelClientServiceDiscount[] | null;
    IsExcludedFromLoyaltyDiscount: boolean;
    /** Услуга с абонемента клиента (ТЗ us/11427) */
    ClientSubscriptionId?: number | null;
  };
}
